"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconLinkName = exports.SecondaryLinkName = exports.PrimaryLinkName = void 0;
var PrimaryLinkName;
(function (PrimaryLinkName) {
    PrimaryLinkName["LearnWithBabbel"] = "learning_with_babbel";
    PrimaryLinkName["App"] = "mobile";
    PrimaryLinkName["Magazine"] = "social.magazine";
    PrimaryLinkName["B2B"] = "b2b.shop";
    PrimaryLinkName["Jobs"] = "jobs";
    PrimaryLinkName["Press"] = "press";
    PrimaryLinkName["Blog"] = "social.blog";
    PrimaryLinkName["Tech"] = "social.tech";
    PrimaryLinkName["Faq"] = "faq";
    PrimaryLinkName["Gift"] = "gift";
})(PrimaryLinkName = exports.PrimaryLinkName || (exports.PrimaryLinkName = {}));
;
var SecondaryLinkName;
(function (SecondaryLinkName) {
    SecondaryLinkName["Imprint"] = "legal.imprint";
    SecondaryLinkName["Copyright"] = "legal.copyright";
    SecondaryLinkName["Terms"] = "legal.terms";
    SecondaryLinkName["Privacy"] = "legal.privacy";
    SecondaryLinkName["CancelSubscription"] = "legal.cancel_subscription";
})(SecondaryLinkName = exports.SecondaryLinkName || (exports.SecondaryLinkName = {}));
;
var IconLinkName;
(function (IconLinkName) {
    IconLinkName["Twitter"] = "social.twitter";
    IconLinkName["Facebook"] = "social.facebook";
    IconLinkName["Youtube"] = "social.youtube";
    IconLinkName["Instagram"] = "social.instagram";
    IconLinkName["Linkedin"] = "social.linkedin";
})(IconLinkName = exports.IconLinkName || (exports.IconLinkName = {}));
;
//# sourceMappingURL=linkOption.js.map